export default "__VITE_ASSET__C2Cb4BWz__"